var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputFieldErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error_FILL0_wght400_GRAD0_opsz48",
    d: "M10,13a.487.487,0,1,0-.352-.142A.479.479,0,0,0,10,13Zm-.405-2.3h.9V6.91h-.9ZM10,16a5.806,5.806,0,0,1-2.325-.472,6.045,6.045,0,0,1-3.2-3.2,5.993,5.993,0,0,1,0-4.665,6,6,0,0,1,1.29-1.9A6.151,6.151,0,0,1,7.675,4.473a5.993,5.993,0,0,1,4.665,0A5.991,5.991,0,0,1,15.528,7.66a5.993,5.993,0,0,1,0,4.665,6.151,6.151,0,0,1-1.283,1.912,6,6,0,0,1-1.905,1.29A5.843,5.843,0,0,1,10,16Zm.015-.9a4.89,4.89,0,0,0,3.6-1.493A4.945,4.945,0,0,0,15.1,9.985a4.9,4.9,0,0,0-1.485-3.6A4.92,4.92,0,0,0,10,4.9,4.927,4.927,0,0,0,6.393,6.385,4.908,4.908,0,0,0,4.9,10a4.915,4.915,0,0,0,1.493,3.608A4.932,4.932,0,0,0,10.015,15.1ZM10,10Z",
    transform: "translate(-4 -4)",
    fill: "#b52323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputFieldErrorIcon);
export default __webpack_public_path__ + "static/media/InputFieldErrorIcon.28b53308dcda4a4276c4206b0658ad65.svg";
export { ForwardRef as ReactComponent };